
export enum LoadStatus {
    LOADING = 'loading',
    LOADED = 'loaded',
    FAILED = 'failed'
}